import { Injectable, NgModule, ModuleWithProviders } from '@angular/core';
import { NgxsPlugin, getActionTypeFromInstance } from '@ngxs/store';
import { NGXS_PLUGINS } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { UserService } from '../services/user.service';
import { interval } from 'rxjs';
import { UserAction } from '../model/model';

@Injectable()
export class NgxsActionLoggerBackendPlugin implements NgxsPlugin {

  constructor(private userService: UserService) {
    interval(10000).pipe(tap(_ => {
      if (!!userService.user) {
        const storedActions = sessionStorage.getItem('teacher_actions');
        const userActions = storedActions ? <UserAction[]>JSON.parse(storedActions) : [];
        if (userActions && userActions.length > 0) {
          this.userService.logActions(userActions).subscribe(_1 => {
            sessionStorage.removeItem('teacher_actions');
          });
        }
      }
    }))
      .subscribe();
  }

  handle(state, event, next) {
    const actionName = getActionTypeFromInstance(event);
    return next(state, event).pipe(
      tap(_ => {
        const storedActions = sessionStorage.getItem('teacher_actions');
        const userActions = storedActions ? <UserAction[]>JSON.parse(storedActions) : [];
        userActions.push(<UserAction>{ action: actionName, isTeacher: true, trucatedPayload: JSON.stringify(event).slice(0, 50) });
        sessionStorage.setItem('teacher_actions', JSON.stringify(userActions));
      }));
  }
}

@NgModule()
export class NgxsActionLoggerToBackendPluginModule {
  static forRoot(): ModuleWithProviders<NgxsActionLoggerToBackendPluginModule> {
    return {
      ngModule: NgxsActionLoggerToBackendPluginModule,
      providers: [
        {
          provide: NGXS_PLUGINS,
          useClass: NgxsActionLoggerBackendPlugin,
          multi: true
        }
      ]
    };
  }
}
